// extracted by mini-css-extract-plugin
module.exports = {"main":"default_main__pivSY","bg":"default_bg__D4Yqf","text_box":"default_text_box__3gk3U"};